module.exports = __webpack_public_path__ + "static/media/image 94.ea76071b.webp";